import {notPlayableMedia} from "constants/notPlayableMedia";
import getBrowser from "./getBrowser";
import getFileExtension from "./getFileExtension";

function isNotPlayableMedia (fileName: string): boolean {
  const extension = getFileExtension(fileName)?.toLowerCase();
  return notPlayableMedia[getBrowser()]?.includes(extension!);
}

export default isNotPlayableMedia;